

import { Routes, Route } from "react-router-dom"
import Home from './components/Home';
import './App.css';
import Coach from "./components/Coach";
import PaymentPage from "./components/PaymentPage";
import Offering from "./components/Offering";
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import RefundPolicy from "./components/RefundPolicy";
import ContactUs from "./components/ContactUs";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={ <Home /> } />
        <Route path="/coach" element={ <Coach/> } />
        <Route path="/payment" element={ <PaymentPage/> } />
        <Route path="/offering/:offeringId" element={ <Offering/> } />
        <Route path="/terms-and-conditions" element={ <TermsAndConditions/> } />
        <Route path="/privacy-policy" element={ <PrivacyPolicy/> } />
        <Route path="/refund-policy" element={ <RefundPolicy/> } />
        <Route path="/contact-us" element={ <ContactUs/> } />
        <Route path="/:groupname" element={ <Home/> } />
        {/* <Route path="*" element={ <PageNotFound/> } /> */}
      </Routes>
    </div>
  );
}

export default App;
